module.exports = __webpack_public_path__ + "static/media/1-beauty-lunch.20c16e4b.jpg";